import getClassNames from 'classnames';
import React from 'react';
import Element, { CommonProps } from '../../Element/Element';

import styles from '../Table.module.scss';
import { tableTypeOption } from '../TableCell/TableCell';
import { ArrayElementType } from '../../../types/utils/ArrayElementType';

const sortingOptions = ['asc', 'desc', false] as const;

export type sortingOptionType = ArrayElementType<typeof sortingOptions>;

type TableHeaderCellProps = {
  /**  Allows TableCells to adjust accordingly. */
  type?: tableTypeOption;
  /** Set aria-sort direction */
  sortDirection?: sortingOptionType;
  /** If content doesn't fit to the cell, the word is cut and wrapped to the next row. This props adds word-break: break-all style to the cell */
  breakWord?: boolean;
  ref?: React.Ref<HTMLTableHeaderCellElement>;
} & Omit<CommonProps<'th'>, 'tagName' | 'ref'>;

const TableHeaderCell: React.FunctionComponent<TableHeaderCellProps> = React.forwardRef(
  function TableHeaderCell(
    { className, children, sortDirection, breakWord, type, ...props },
    ref: React.Ref<HTMLTableHeaderCellElement>
  ) {
    const classNames = getClassNames(
      styles.table_cell,
      styles.table_cell_header,
      { [styles.table_cell_checkbox]: type === 'checkbox' },
      { [styles.table_cell__breakWord]: breakWord },
      className
    );

    let ariaSort: 'ascending' | 'descending' | 'other' | 'none' | null = null;
    if (sortDirection as sortingOptionType) {
      ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    }

    return (
      <Element
        tagName="th"
        className={classNames}
        aria-sort={ariaSort as 'none' | 'ascending' | 'descending' | 'other'}
        ref={ref}
        {...props}
      >
        {children}
      </Element>
    );
  }
);

export default TableHeaderCell;
